/**
 * Dispara um toast local reaproveitando a UI de <ToastNotificacoes>, que escuta
 * o evento window "growsoft:notificacao.nova". Serve para avisos de interface que
 * NÃO vêm do servidor (ex.: card desviado para "Aprovação interna" ao arrastar).
 *
 * lida:true evita que clicar chame marcarComoLida (id é sintético, não existe no
 * backend). Com referenciaId, o tipo "tarefa_" faz o clique abrir o card.
 */
export function avisoToast(titulo: string, mensagem: string, referenciaId?: string) {
  if (typeof window === "undefined") return;
  const id = `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  window.dispatchEvent(
    new CustomEvent("growsoft:notificacao.nova", {
      detail: {
        id,
        titulo,
        mensagem,
        tipo: referenciaId ? "tarefa_aviso_local" : "aviso_local",
        referenciaId: referenciaId ?? null,
        lida: true,
        criadaEm: new Date().toISOString(),
      },
    }),
  );
}
